
import { BlogPost } from "@/types/blog";

export const post: BlogPost = {
  slug: "2024-i-codes-adoption",
  title: "2024 I-Codes Adoption: New Year, New Codes",
  excerpt: "Exploring the newly released 2024 I-Codes and their implications for construction methods, energy efficiency, and municipal adoption strategies.",
  content: `
      <h2>Code Application</h2>
      
      <p>
        With the release of a new code cycle comes new requirements and interpretations. 
        Since states (and some local municipalities) are able to outright adopt, delete or 
        amend any portion of I-Code they deem necessary, this can quickly get complex. 
        Since not every part of a code book applies to the various geographies or community 
        needs across the US, it's in a governing jurisdiction's best interest to tailor the 
        code to their specific needs.
      </p>
      
      <h2>National codes are ever changing. That's a good thing.</h2>
      
      <p>
        The ICC recently released the 2024 I-Codes, which come with a slew of updates, 
        clarifications and new appendices for States or Local Municipalities to adopt. 
        Focusing on the International Residential Code, there are a myriad of new energy 
        efficiency requirements that will be adopted by municipalities in 2025 and beyond.
      </p>
      
      <h2>What Code Cycles tell us about Construction Methods.</h2>
      
      <p>
        Looking specifically at the 2018 International Residential Code, we notice that 
        a focus on alternative housing (manufactured, tiny homes, building re-purposing, etc.) 
        is front and center within the appendices. As we move into the 2021 cycle, the focus 
        shifts to more specialized building methods and practices. With the release of the 
        2024 code cycle, a shift to renewable energy generation, energy efficiency, and housing 
        densification is very apparent.
      </p>
      
      <div class="mb-8 overflow-hidden rounded-lg">
        <img 
          src="/lovable-uploads/e6050a3a-d3eb-4288-b878-5cce90f5716d.png" 
          alt="International Residential Code Cycles Appendix Comparison showing evolution from 2018 to 2024"
          class="w-full object-cover"
        />
      </div>
      
      <p>
        A vast majority of municipalities won't adopt all of these appendices, but now they 
        have more customization options and provisions to items that they want to adapt, 
        change and enforce. Since the inclusion of specialized appendices can be seen 
        across all I-Code books, 2025 will be an interesting year of State and Local adoption!
      </p>
  `,
  coverImage: "https://images.unsplash.com/photo-1457369804613-52c61a468e7d?q=80&w=2970&auto=format&fit=crop",
  date: "2025-01-02T11:15:00",
  readTime: 5,
  categories: ["Construction", "City Codes", "Regulations"],
  author: {
    name: "Richie Rasor",
    title: "Co-founder & CSO",
    avatar: "/lovable-uploads/26c946ec-4296-4ac9-9351-78321594ea25.png"
  }
};
